import React, { type ReactNode } from 'react'
import { css } from '@emotion/core'

const separatorBorderCss = css`
  border: 1px solid transparent;
`

export default function SeparatorBorder({ children }: { children: ReactNode }): JSX.Element {
  return <div css={separatorBorderCss}>{children}</div>
}
